import React, { useState } from 'react';
import { BaseInputProps, LoadingAnimation, MultiSelectDropdown } from 'ui-builder';
import { DocumentLabel, useDocumentLabelsService } from 'nekst-api';
import useDataLoader from 'data-loader';

export interface DocumentsLabelDropdownProps extends BaseInputProps<number[]> {
  excludeIds?: number[],
}

export function DocumentLabelsDropdown(props: DocumentsLabelDropdownProps) {
  const service = useDocumentLabelsService();

  const [labels, setLabels] = useState<DocumentLabel[]>();

  useDataLoader(
    service.getLabels,
    setLabels,
  );

  if (labels) {
    const options = labels
      .filter((item) => !props.excludeIds?.includes(item.id))
      .map((item) => ({
        label: item.name,
        value: item.id,
      }));

    return (
      <MultiSelectDropdown
        {...props}
        options={options}
        onOptionCreate={
          async (value: string) => {
            const label = await service.createLabel({
              name: value,
            });

            return {
              value: label.id,
              label: label.name,
            };
          }
        }
        placeholder="Select a label or enter the name of a new one..."
      />
    );
  } else {
    return <LoadingAnimation />;
  }
}
